import { EMPTY_VALUE } from '@/constants/app.constants';
import { formatNumber } from '@/utils/number';
import type { ExpenseHeaderLine } from '../types/billing.types';
import { DetailLinesTable, type DetailLineColumn } from './DetailLinesTable';
import { VerifyStatusBadge } from './VerifyStatusBadge';

function VendorWithRoute({ line }: { line: ExpenseHeaderLine }) {
  const route = [line.fromLocation, line.toLocation].filter(Boolean).join(' → ');

  return (
    <>
      <span className="block">{line.vendor ?? EMPTY_VALUE}</span>
      {route ? <span className="block text-xs text-muted-foreground">{route}</span> : null}
    </>
  );
}

const EXPENSE_ITEM_COLUMNS: DetailLineColumn<ExpenseHeaderLine>[] = [
  { header: 'Expense Type', render: (line) => line.approveExpenseType ?? line.expenseType },
  { header: 'Vendor / Person', render: (line) => <VendorWithRoute line={line} /> },
  { header: 'Claimed', isNumeric: true, render: (line) => formatNumber(line.amount) },
  { header: 'Approved', isNumeric: true, render: (line) => formatNumber(line.approveAmount) },
  {
    header: 'Status',
    render: (line) => <VerifyStatusBadge status={line.approveStatus} decisionKind="approve" />,
  },
];

interface ExpenseItemsTableProps {
  lines: ExpenseHeaderLine[];
}

export function ExpenseItemsTable({ lines }: ExpenseItemsTableProps) {
  return (
    <DetailLinesTable
      title="Expense Items"
      lines={lines}
      columns={EXPENSE_ITEM_COLUMNS}
      getLineKey={(line) => line.detailId}
    />
  );
}
